// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import Component from "../../../../app/lib/jGia/jGia/src/Component";
import eventbus from "../../../../app/lib/jGia/jGia/src/eventbus";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import logger from "../../../../app/baseUtilities/logger";
import cancel_featureInit from "../../../../app/baseUtilities/cancel/cancel_featureInit";

// —————————————————————————————————————— INITIALIZATION F() —————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import init_eventLinks from "./init/init_eventLinks.js";

// ————————————————————————————— EVENT/EVENTBUS/STATE CHANGE HANDLERS ————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import ebh_window_resize from "./eventbusHandlers/ebh_window_resize.js";
import ebh_ScrollArea_scroll from "./eventbusHandlers/ebh_ScrollArea_scroll.js";

import stChH_activeMonth from "./stateChangeHandlers/stChH_activeMonth.js";
import stChH_activeEvent from "./stateChangeHandlers/stChH_activeEvent.js";
import stChH_bgImgUrl from "./stateChangeHandlers/stChH_bgImgUrl.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Options with case-sensitive keys that are not to be
// automatically extracted from the options arg. but be
// assigned to an option key manually to preserve its case
// (Kirby CMS converts all fields/option keys to lowercase)
// (see constructor).

const manualOptionKeys = ["optionkey"];

//  Default values for manually extracted options
//  (see constructor, in case specific option has not been provided
//  in comp. config.).

const defaultOptions = {
  optionkey: { foo: "bar" },
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

class Calendar extends Component {
  ///////////////////////////// Constructor //////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  constructor(element, options) {
    super(element);

    ///////// DOM references //////////
    ///////////////////////////////////

    this.ref = {
      monthHeadings: [],
      eventLinks: [],
      background: null,
      backgroundLayers: [],
    };

    //////////// Options /////////////
    //////////////////////////////////

    // Get options not to be manually extracted from the options arg...
    const autoOptions = {};
    for (const key in options) if (!manualOptionKeys.includes(key)) autoOptions[key] = options[key];

    this.options = {
      name: "Calendar",
      // optionKey: options.optionkey,
      ...autoOptions,
    };

    //////////// Utilities /////////////
    ////////////////////////////////////

    this.logger = logger.bind(this);
    this.cancel_featureInit = cancel_featureInit.bind(this);

    //////////// Init. f() /////////////
    ////////////////////////////////////

    this.init_eventLinks = init_eventLinks.bind(this);

    ///////////// Modules //////////////
    ////////////////////////////////////

    // ...

    //////// Eventbus listeners ////////
    ////////////////////////////////////

    this.ebl_window_resize = ebh_window_resize.bind(this);
    this.ebl_ScrollArea_scroll = ebh_ScrollArea_scroll.bind(this);

    ////// State-change listeners //////
    ////////////////////////////////////

    this.stChL_activeMonth = stChH_activeMonth.bind(this);
    this.stChL_activeEvent = stChH_activeEvent.bind(this);
    this.stChL_bgImgUrl = stChH_bgImgUrl.bind(this);

    ////// Custom event handlers ///////
    // (To be passed to parent class) //

    ///////// Pre-mount init. //////////
    ////////////////////////////////////

    // ...
  }

  //////////////////////////////// Mount /////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  mount() {
    this.logger("info", ["mounting"], "action", { inline: true });
    this.init();
  }

  /////////////////////////////// Unmount ////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  unmount() {
    this.logger("info", ["unmounting"], "action", { inline: true });

    ///////////////////////////////////
    // Unregister eventbus listeners //
    ///////////////////////////////////

    eventbus.off("window_resize", this.ebl_window_resize);
    eventbus.off("ScrollArea_scroll", this.ebl_ScrollArea_scroll);
  }

  ///////////////////////////////// Init. ////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  init() {
    this.init_eventLinks();
    this.init_states();
    this.init_eventbus();
  }

  ////////////////////////////////////
  ////////////////////////////////////

  init_states() {
    this.logger("init", ["states"], "action", { inline: true });
    this.setState({
      activeMonth: 0,
      is_mobile: window.innerWidth < 640,
    });
  }

  ////////////////////////////////////
  ////////////////////////////////////

  init_eventbus() {
    this.logger("init", ["eventbus"], "action", { inline: true });

    /////////////////////////////////
    // Register eventbus listeners //
    /////////////////////////////////

    eventbus.on("window_resize", this.ebl_window_resize);
    eventbus.on("ScrollArea_scroll", this.ebl_ScrollArea_scroll);
  }

  //////////////////////////// State Changes /////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  stateChange(CHANGES) {
    /////////// activeMonth ///////////
    ////////////////////////////////////

    if ("activeMonth" in CHANGES) this.stChL_activeMonth(CHANGES);

    /////////// activeEvent ///////////
    ////////////////////////////////////

    if ("activeEvent" in CHANGES) this.stChL_activeEvent(CHANGES);

    ///////////// bgImgUrl /////////////
    ////////////////////////////////////

    if ("bgImgUrl" in CHANGES) this.stChL_bgImgUrl(CHANGES);
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default Calendar;
